<section>
  <app-tab-nav (clicked)="tabNavEvent($event)" [tabs]="tabs" styleWidth="50%"></app-tab-nav>
  <router-outlet></router-outlet>
</section>
